export default {
  /**
   *
   * @param {HTMLElement} el provided by vue.
   * @param {*} options provied by vue.
   * @param {String} options.value.color default value edit
   * @param {String} options.value.targetSelector Required value. Value CSS selector
   * @returns void
   */
  mounted(el, { value }) {
    if (!value) return;
    window.requestAnimationFrame(() => {
      const { color = "edit", targetSelector } = value;

      const target = el.closest(targetSelector);

      const targetRect = target.getClientRects()[0];
      if (!targetRect) return;

      const line = document.createElement("div");
      line.className = `edit-line`;
      line.style.height = String(targetRect.height) + "px";
      line.style.width = "2px";
      line.style.position = "absolute";
      // window.scrolY is needed because targetRect.top is relative to viewport.
      // Meanning user scrolling gives different targetRect.top. Adding window.scrollY patches it so
      // the line will always show up next to element, not being 200px above.
      // found it from stackoverflow
      line.style.display = "none";
      line.style.top = targetRect.top + window.scrollY + "px";
      line.style.left = targetRect.right + window.scrollX + 20 + "px";
      line.style.background = `rgb(var(--v-theme-${color}))`;

      const existingLines = document.querySelectorAll(".edit-line").length;
      line.id = `edit-${existingLines}-vertical-line-id`;
      el.setAttribute("aria-controls", line.id);

      document.body.append(line);

      function showLine() {
        if (window.innerWidth <= 960) return;
        line.style.display = "block";
      }

      function hideLine() {
        line.style.display = "none";
      }

      el.addEventListener("mouseenter", showLine);
      el.addEventListener("mouseleave", hideLine);
    });
  },
  unmounted(el) {
    const lineId = el.getAttribute("aria-controls");
    const line = document.getElementById(lineId);
    if (line) {
      document.body.removeChild(line);
    }
  }
};
